import React, { useEffect, useState } from 'react';
import {
  Box, Grid, Paper, Typography, CircularProgress, Alert,
  Card, CardContent,
} from '@mui/material';
import {
  People as PeopleIcon,
  Home as HomeIcon,
  AttachMoney as MoneyIcon,
  Warning as WarningIcon,
  Business as BusinessIcon,
  MeetingRoom as RoomIcon,
} from '@mui/icons-material';
import adminService from '../../services/adminService';

const StatCard = ({ title, value, icon, color }) => (
  <Card elevation={2}>
    <CardContent>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography variant="body2" color="text.secondary">{title}</Typography>
          <Typography variant="h4" fontWeight="bold" color={color || 'text.primary'}>
            {value}
          </Typography>
        </Box>
        <Box sx={{ color: color || 'primary.main', opacity: 0.7 }}>{icon}</Box>
      </Box>
    </CardContent>
  </Card>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    adminService.getPlatformStats()
      .then(setStats)
      .catch(() => setError('Failed to load platform stats'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Box display="flex" justifyContent="center" mt={4}><CircularProgress /></Box>;
  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Platform Overview
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        {new Date().toLocaleString('default', { month: 'long', year: 'numeric' })}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard title="Total Landlords" value={stats.total_landlords}
            icon={<BusinessIcon sx={{ fontSize: 40 }} />} color="primary.main" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard title="Total Tenants" value={stats.total_tenants}
            icon={<PeopleIcon sx={{ fontSize: 40 }} />} color="success.main" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard title="Total Rooms" value={stats.total_rooms}
            icon={<HomeIcon sx={{ fontSize: 40 }} />} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard title="Occupied Rooms" value={stats.occupied_rooms}
            icon={<RoomIcon sx={{ fontSize: 40 }} />} color="info.main" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title={`Monthly Income (${stats.month}/${stats.year})`}
            value={`KES ${stats.monthly_income.toLocaleString()}`}
            icon={<MoneyIcon sx={{ fontSize: 40 }} />} color="success.main" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard title="Total Outstanding" value={`KES ${stats.total_outstanding.toLocaleString()}`}
            icon={<WarningIcon sx={{ fontSize: 40 }} />} color="warning.main" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboard;
